"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const utils_1 = require("../utils");
/**
 * Removes course from calls history when uncalled.
 * @param event of type CourseUncalledEvent
 * @param prevState previous order
 */
function default_1(event, prevState = {}) {
    const order = (0, utils_1.clone)(prevState);
    // If no course calls exist, return the order unchanged
    if (!order.courseCalls || order.courseCalls.length === 0) {
        return order;
    }
    // Filter out the course with the matching courseId
    const filteredCourseCalls = order.courseCalls.filter(call => call.courseId !== event.courseId);
    return {
        ...order,
        courseCalls: filteredCourseCalls.sort((a, b) => b.calledAt - a.calledAt),
    };
}
exports.default = default_1;
//# sourceMappingURL=orderCourseUncalled.js.map